import { cn } from "@/lib/utils";

interface StatsIndicatorsProps {
  habitsCount: number;
  adultsCount: number;
  totalStreak: number;
  className?: string;
}

export const StatsIndicators = ({
  habitsCount,
  adultsCount,
  totalStreak,
  className,
}: StatsIndicatorsProps) => {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div className="flex items-center gap-1 px-2 py-1 bg-coral/10 rounded-full">
        <span className="text-sm font-bold text-coral">{habitsCount}</span>
        <span className="text-xs text-muted-foreground hidden sm:inline">hábitos</span>
      </div>
      <div className="flex items-center gap-1 px-2 py-1 bg-golden/10 rounded-full">
        <span className="text-sm font-bold text-golden">{adultsCount}</span>
        <span className="text-xs text-muted-foreground hidden sm:inline">🐸</span>
      </div>
      <div className="flex items-center gap-1 px-2 py-1 bg-teal/10 rounded-full">
        <span className="text-sm font-bold text-teal">{totalStreak}</span>
        <span className="text-xs">🔥</span>
      </div>
    </div>
  );
};
